export default __webpack_public_path__ + "src/assets/help.7a6d9408e5861ea23afb6fe1d8e8aa83.svg";